export type GridTemplate = "three-columns" | "two-columns-left" | "two-columns-right" | "two-columns-equal" | "one-wide-two-narrow" | "sidebar-center" | "centered" | "single-column";

export interface GridTemplateConfig {
  id: GridTemplate;
  nameKey: string;
  widths: number[];
  rowHeight: number;
}

export const GRID_TEMPLATES: GridTemplateConfig[] = [
  {
    id: "three-columns",
    nameKey: "admin.grid.template.three-columns",
    widths: [4, 4, 4],
    rowHeight: 6,
  },
  {
    id: "two-columns-left",
    nameKey: "admin.grid.template.two-columns",
    widths: [8, 4],
    rowHeight: 6,
  },
  {
    id: "two-columns-right",
    nameKey: "admin.grid.template.two-columns-right",
    widths: [4, 8],
    rowHeight: 6,
  },
  {
    id: "two-columns-equal",
    nameKey: "admin.grid.template.two-columns-equal",
    widths: [6, 6],
    rowHeight: 6,
  },
  {
    id: "one-wide-two-narrow",
    nameKey: "admin.grid.template.one-wide-two-narrow",
    widths: [6, 3, 3],
    rowHeight: 6,
  },
  {
    id: "sidebar-center",
    nameKey: "admin.grid.template.sidebar-center",
    widths: [3, 6, 3],
    rowHeight: 6,
  },
  {
    id: "centered",
    nameKey: "admin.grid.template.centered",
    widths: [2, 8, 2],
    rowHeight: 6,
  },
  {
    id: "single-column",
    nameKey: "admin.grid.template.single-column",
    widths: [12],
    rowHeight: 6,
  },
];
